import { render } from "./PatientComponent.vue?vue&type=template&id=4a306180"
import script from "./PatientComponent.vue?vue&type=script&lang=js"
export * from "./PatientComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__